export default "__VITE_ASSET__BKNVT2gu__"